import { useModelContext } from '@app/contexts/model';
import { useStorageUserConfigContext } from '@app/modules/UserConfig/contexts/storage';
import { Checkbox, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React, { FC } from 'react';

type TProps = {};

export const TargetLanguage: FC<TProps> = observer((props: TProps) => {
    const { userConfigStore } = useStorageUserConfigContext();
    const { languageModel } = useModelContext();

    const categoryLangResponse = languageModel.dataCategory.get();

    const handleToggle = (value: string) => () => {
        runInAction(() => {
            if (userConfigStore.targetLanguagesChosenIdSet.includes(value)) {
                userConfigStore.targetLanguagesChosenIdSet.remove(value);
            } else {
                userConfigStore.targetLanguagesChosenIdSet.push(value);
            }
        });
    };

    return (
        <List>
            <Typography>
                Target languages selection <br />
                (select at least one)
            </Typography>
            {categoryLangResponse &&
                categoryLangResponse.target.map((value) => {
                    const labelId = `checkbox-list-label-${value.key}`;
                    return (
                        <ListItemButton key={value.key} role={undefined} onClick={handleToggle(value.key)} dense>
                            <ListItemIcon>
                                <Checkbox edge='start' checked={userConfigStore.targetLanguagesChosenIdSet.includes(value.key)} tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': labelId }} />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={`${value.name}`} />
                        </ListItemButton>
                    );
                })}
        </List>
    );
});
